import { tns } from "tiny-slider"

// SLIDER FURTHER
var further_slider = document.querySelectorAll(".js-further-slider");
if (further_slider.length) {
  var slider_further = tns({
    container: '.js-further-slider',
    items: 1,
    autoplay: false
    "responsive": {
        "850": {
          "items": 3
        },
        "500": {
          "items": 2
        }
      },
  });
}


// SLIDER BOX
var box_slider = document.querySelectorAll(".js-slider-box");
if (box_slider.length) {
  var slider_box = tns({
    container: '.js-slider-box',
    items: 1,
    autoplay: false
  });
}


// SLIDER Home
var box_homes = document.querySelectorAll(".js-slider-home");
box_homes.forEach(function(box){
  if (box_homes.length) {
    console.log(box);
    var slider_box = tns({
      container: box,
      items: 1,
      autoplay: false,
      speed: 1000
    });
  }
});
